<template>
    <div class="main_body">
        <div class="container">
            <!-- 第一个分类 -->
            <main-body-goods
                :goods="firstList"
                :cate="firstCate">
            </main-body-goods>
            <!-- 广告图 -->
            <div class="main-body-banner-pic"
                v-if="main_banner.length">
                <img :src="main_banner[0].advertising_image">
            </div>
            <!-- 第二个分类 -->
            <main-body-goods
                :goods="secondList"
                :cate="secondCate"
                :tabs="secondTabs"
                num="2">
            </main-body-goods>
            <!-- 第三分类 -->
            <main-body-goods
                :goods="thirdList"
                :cate="thirdCate"
                :tabs="thirdTabs"
                num="3">
            </main-body-goods>
            <!-- 广告图 -->
            <div class="main-body-banner-pic"
                v-if="main_banner.length">
                <img :src="main_banner[1].advertising_image">
            </div>
            <!-- 第四分类 -->
            <main-body-goods
                :goods="fourthList"
                :cate="fourthCate"
                :tabs="fourthTabs"
                num="4">
            </main-body-goods>
            <!-- 产品试用说明 -->
            <main-body-instructions></main-body-instructions>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: mapState({
        firstList: state => state.goods.firstList, // 1-商品
        firstCate: state => state.goods.firstCate, // 1-分类
        secondList: state => state.goods.secondList, // 2-商品
        secondCate: state => state.goods.secondCate, // 2-分类
        secondTabs(state){
            for(let item of state.banner.menu){
                if(item.id == state.goods.secondCate.id){
                    return item.child
                }
            }
        }, // 2-分类标签
        thirdList: state => state.goods.thirdList, // 3-商品
        thirdCate: state => state.goods.thirdCate, // 3-分类
        thirdTabs(state){
            for(let item of state.banner.menu){
                if(item.id == state.goods.thirdCate.id){
                    return item.child
                }
            }
        }, // 3-分类标签
        fourthList: state => state.goods.fourthList, // 4-商品
        fourthCate: state => state.goods.fourthCate, // 4-分类
        fourthTabs(state){
            for(let item of state.banner.menu){
                if(item.id == state.goods.fourthCate.id){
                    return item.child
                }
            }
        }, // 4-分类标签
        fifthList: state => state.goods.fifthList, // 5-商品
        fifthCate: state => state.goods.fifthCate, // 5-分类
        main_banner: state => state.banner.main_banner
    }),
    components: {
        mainBodyGoods: () => import("@/components/mainBodyGoods"),
        mainBodyInstructions: () => import("@/components/mainBodyInstructions")
    },
}
</script>

<style scoped>
/* 组件盒子 */
.main_body{
    min-height: 500px;
    padding: 50px 0;
    background: #f5f5f5;
    min-width: 1200px;
}
/* 分类间广告图片 */
.main-body-banner-pic{
    margin-top: 30px;
}
.main-body-banner-pic>img{
    width: 100%;
}
</style>
